// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { infoCardStyles } from "@pace/App/Components/WhyPace/InfoCard";
import IconArrowRight from "@pace/XDL/Icons/IconArrowRight";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { getSystemColor, hideElementOnPrint } from "@pace/XDL/Utilities";
import { css } from "styled-components";

infoCardStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        min-height: 100%;
        width: 100%;
        @media print {
            page-break-inside: avoid;
        }
    `,
};
infoCardStyles.imageWrapper = {
    css: css`
        width: 100%;
        height: 210px;
    `,
};
infoCardStyles.image = {
    css: css`
        width: 100%;
        max-height: 100%;
        object-fit: cover;
        border-radius: 4px 4px 0 0;
        img {
            height: 100%;
        }
    `,
};
infoCardStyles.cardContentWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        flex: 1;
        padding: 16px;
    `,
};
infoCardStyles.title = {
    forwardAs: "h2",
    variant: "h4",
};
infoCardStyles.subtitle = {
    variant: "p",
};
infoCardStyles.link = {
    color: "secondary",
    hoverStyle: {
        color: getSystemColor("common.ui8"),
    },
    icon: {
        iconProps: {
            src: IconArrowRight,
            mergeCss: true,
            color: "secondary",
            css: css`
                align-self: flex-end;
                opacity: 0.5;
                svg {
                    width: 14px;
                    height: 16px;
                }
            `,
        },
        position: "right",
    },
    typographyProps: {
        size: 16,
        weight: fontConfig.weight.bold,
        css: css`
            letter-spacing: 0;
            line-height: 17px;
            align-self: flex-start;
        `,
    },
    css: css`
        margin-top: 6px;
        ${IconWrapper} {
            margin-left: 6px;
            width: auto;
        }
        @media print {
            ${hideElementOnPrint}
        }
    `,
};
